import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-2 mt-2 lg:mt-0 rounded shadow bg-white" }
const _hoisted_2 = { class: "p-6" }
const _hoisted_3 = { class: "text-xl font-bold" }
const _hoisted_4 = { class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start" }
const _hoisted_5 = { class: "p-2 mt-2 rounded shadow bg-white mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "p-6"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, "回答一覧", -1)
const _hoisted_8 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " サロン "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 回答 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 回答日 ")
  ])
], -1)
const _hoisted_10 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_11 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_12 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_13 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_14 = {
  key: 1,
  class: "p-6"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, "解答", -1)
const _hoisted_16 = { class: "p-6" }
const _hoisted_17 = { class: "mb-2 last:mb-0" }
const _hoisted_18 = { class: "grid grid-cols-1 gap-3 mb-4" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = { class: "block mb-2" }
const _hoisted_21 = {
  key: 0,
  class: "text-xs align-text-top text-red-600 ml-2"
}
const _hoisted_22 = { class: "text-xs text-pink-600" }
const _hoisted_23 = {
  key: 0,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_24 = { class: "relative" }
const _hoisted_25 = { class: "block mb-2" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "text-xs text-pink-600" }
const _hoisted_28 = {
  key: 1,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_29 = { class: "relative" }
const _hoisted_30 = { class: "block mb-2" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = { class: "text-xs text-pink-600" }
const _hoisted_33 = {
  key: 2,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_34 = { class: "relative" }
const _hoisted_35 = { class: "block mb-2" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = { class: "text-xs text-pink-600" }
const _hoisted_38 = {
  key: 3,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_39 = { class: "relative" }
const _hoisted_40 = { class: "block mb-2" }
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = { class: "text-xs text-pink-600" }
const _hoisted_43 = {
  key: 4,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_44 = { class: "relative" }
const _hoisted_45 = { class: "block mb-2" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = { class: "text-xs text-pink-600" }
const _hoisted_48 = {
  key: 5,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_49 = { class: "relative" }
const _hoisted_50 = { class: "block mb-2" }
const _hoisted_51 = ["placeholder"]
const _hoisted_52 = { class: "text-xs text-pink-600" }
const _hoisted_53 = {
  key: 6,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_54 = { class: "relative" }
const _hoisted_55 = { class: "block mb-2" }
const _hoisted_56 = ["placeholder"]
const _hoisted_57 = { class: "text-xs text-pink-600" }
const _hoisted_58 = {
  key: 7,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_59 = { class: "relative" }
const _hoisted_60 = { class: "block mb-2" }
const _hoisted_61 = ["placeholder"]
const _hoisted_62 = { class: "text-xs text-pink-600" }
const _hoisted_63 = {
  key: 8,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_64 = { class: "relative" }
const _hoisted_65 = { class: "block mb-2" }
const _hoisted_66 = ["placeholder"]
const _hoisted_67 = { class: "text-xs text-pink-600" }
const _hoisted_68 = {
  key: 9,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_69 = { class: "relative" }
const _hoisted_70 = { class: "block mb-2" }
const _hoisted_71 = ["placeholder"]
const _hoisted_72 = { class: "text-xs text-pink-600" }
const _hoisted_73 = {
  key: 10,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_74 = { class: "relative" }
const _hoisted_75 = { class: "block mb-2" }
const _hoisted_76 = ["placeholder"]
const _hoisted_77 = { class: "text-xs text-pink-600" }
const _hoisted_78 = {
  key: 11,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_79 = { class: "relative" }
const _hoisted_80 = { class: "block mb-2" }
const _hoisted_81 = ["placeholder"]
const _hoisted_82 = { class: "text-xs text-pink-600" }
const _hoisted_83 = {
  key: 12,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_84 = { class: "relative" }
const _hoisted_85 = { class: "block mb-2" }
const _hoisted_86 = ["placeholder"]
const _hoisted_87 = { class: "text-xs text-pink-600" }
const _hoisted_88 = {
  key: 13,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_89 = { class: "relative" }
const _hoisted_90 = { class: "block mb-2" }
const _hoisted_91 = ["placeholder"]
const _hoisted_92 = { class: "text-xs text-pink-600" }
const _hoisted_93 = {
  key: 14,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_94 = { class: "relative" }
const _hoisted_95 = { class: "block mb-2" }
const _hoisted_96 = ["placeholder"]
const _hoisted_97 = { class: "text-xs text-pink-600" }
const _hoisted_98 = { class: "text-right col-span-full mt-4" }
const _hoisted_99 = ["onClick", "disabled"]

import { FieldContext, useField, useForm } from "vee-validate";
import * as yup from "yup";
import moment from "moment";
import JackRequest from "@/models/JackRequest";
import JackReplyment from "@/models/JackReplyment";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

// interface JackRequestDetailState {
//   // is_loading: boolean;

//   request: JackRequest;
//   replyments: JackReplyment[];

//   replyment_body_field: FieldContext<string>;
//   replyment_body: Ref<string>;
//   replyment_body_error: Ref<string>;

//   answer1_field: FieldContext<string>;
//   answer1: Ref<string>;
//   answer1_error: Ref<string>;

//   answer2_field: FieldContext<string>;
//   answer2: Ref<string>;
//   answer2_error: Ref<string>;

//   answer3_field: FieldContext<string>;
//   answer3: Ref<string>;
//   answer3_error: Ref<string>;

//   answer4_field: FieldContext<string>;
//   answer4: Ref<string>;
//   answer4_error: Ref<string>;

//   answer5_field: FieldContext<string>;
//   answer5: Ref<string>;
//   answer5_error: Ref<string>;

//   answer6_field: FieldContext<string>;
//   answer6: Ref<string>;
//   answer6_error: Ref<string>;

//   answer7_field: FieldContext<string>;
//   answer7: Ref<string>;
//   answer7_error: Ref<string>;

//   answer8_field: FieldContext<string>;
//   answer8: Ref<string>;
//   answer8_error: Ref<string>;

//   answer9_field: FieldContext<string>;
//   answer9: Ref<string>;
//   answer9_error: Ref<string>;

//   answer10_field: FieldContext<string>;
//   answer10: Ref<string>;
//   answer10_error: Ref<string>;

//   answer11_field: FieldContext<string>;
//   answer11: Ref<string>;
//   answer11_error: Ref<string>;

//   answer12_field: FieldContext<string>;
//   answer12: Ref<string>;
//   answer12_error: Ref<string>;

//   answer13_field: FieldContext<string>;
//   answer13: Ref<string>;
//   answer13_error: Ref<string>;

//   answer14_field: FieldContext<string>;
//   answer14: Ref<string>;
//   answer14_error: Ref<string>;

//   answer15_field: FieldContext<string>;
//   answer15: Ref<string>;
//   answer15_error: Ref<string>;
// }

// export default defineComponent({
//   data() {


export default /*#__PURE__*/_defineComponent({
  __name: 'JackRequestDetail',
  setup(__props) {

// import { defineComponent, Ref } from "vue";
const store = useStore();
const route = useRoute();
const router = useRouter();

const formSchema = yup.object({
  replyment_body: yup.string().required("必須項目です"),
  answer1: yup.string(),
  answer2: yup.string(),
  answer3: yup.string(),
  answer4: yup.string(),
  answer5: yup.string(),
  answer6: yup.string(),
  answer7: yup.string(),
  answer8: yup.string(),
  answer9: yup.string(),
  answer10: yup.string(),
  answer11: yup.string(),
  answer12: yup.string(),
  answer13: yup.string(),
  answer14: yup.string(),
  answer15: yup.string(),
});

useForm({ validationSchema: formSchema });

const replyment_body_field = useField<string>("replyment_body");
const answer1_field = useField<string>("answer1");
const answer2_field = useField<string>("answer2");
const answer3_field = useField<string>("answer3");
const answer4_field = useField<string>("answer4");
const answer5_field = useField<string>("answer5");
const answer6_field = useField<string>("answer6");
const answer7_field = useField<string>("answer7");
const answer8_field = useField<string>("answer8");
const answer9_field = useField<string>("answer9");
const answer10_field = useField<string>("answer10");
const answer11_field = useField<string>("answer11");
const answer12_field = useField<string>("answer12");
const answer13_field = useField<string>("answer13");
const answer14_field = useField<string>("answer14");
const answer15_field = useField<string>("answer15");

//     return {
//       // is_loading: false,

const request = ref<JackRequest>({} as JackRequest);
const replyments = ref<JackReplyment[]>([]);

const replyment_body = replyment_body_field.value;
const replyment_body_error = replyment_body_field.errorMessage;

const answer1 = answer1_field.value;
const answer1_error = answer1_field.errorMessage;

const answer2 = answer2_field.value;
const answer2_error = answer2_field.errorMessage;

const answer3 = answer3_field.value;
const answer3_error = answer3_field.errorMessage;

const answer4 = answer4_field.value;
const answer4_error = answer4_field.errorMessage;

const answer5 = answer5_field.value;
const answer5_error = answer5_field.errorMessage;

const answer6 = answer6_field.value;
const answer6_error = answer6_field.errorMessage;

const answer7 = answer7_field.value;
const answer7_error = answer7_field.errorMessage;

const answer8 = answer8_field.value;
const answer8_error = answer8_field.errorMessage;

const answer9 = answer9_field.value;
const answer9_error = answer9_field.errorMessage;

const answer10 = answer10_field.value;
const answer10_error = answer10_field.errorMessage;

const answer11 = answer11_field.value;
const answer11_error = answer11_field.errorMessage;

const answer12 = answer12_field.value;
const answer12_error = answer12_field.errorMessage;

const answer13 = answer13_field.value;
const answer13_error = answer13_field.errorMessage;

const answer14 = answer14_field.value;
const answer14_error = answer14_field.errorMessage;

const answer15 = answer15_field.value;
const answer15_error = answer15_field.errorMessage;
//     } as JackRequestDetailState;
//   },

//   computed: {
const is_system = computed<boolean>(() => {
  return store.state.role == "system";
});

const is_salon = computed<boolean>(() => {
  return !!store.state.salon_id;
});

const salon_id = computed<string | null>(() => {
  return store.state.salon_id;
});
//   },

//   mounted() {
//     console.log("a");
//     refresh();
//   },

onMounted(() => {
  refresh();
});

//   methods: {
const formatDate = (date: Date, format: string) => {
  return moment(date).format(format);
};

const refresh = () => {
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);

  console.log(route);
  const id = route.params.jack_request_id as string;

  setTimeout(async () => {
    try {
      request.value = await JackRequest.get(id);
      // const result1 = await Shop.search(id);
      // shops = result1.shops;
      // console.log(shops);

      // const result2 = await Staff.searchByDealerId(id);
      // staffs = result2.staffs;
      // console.log(shops);

      if (is_system.value) {
        const result = await JackReplyment.search(id);
        replyments.value = (await result).replyments;
      }

      if (is_salon.value) {
        const replyment = await JackReplyment.get(id, salon_id.value!);

        if (replyment) {
          replyment_body.value = replyment.replyment_body;
          answer1.value = replyment.answer1 || "";
          answer2.value = replyment.answer2 || "";
          answer3.value = replyment.answer3 || "";
          answer4.value = replyment.answer4 || "";
          answer5.value = replyment.answer5 || "";
          answer6.value = replyment.answer6 || "";
          answer7.value = replyment.answer7 || "";
          answer8.value = replyment.answer8 || "";
          answer9.value = replyment.answer9 || "";
          answer10.value = replyment.answer10 || "";
          answer11.value = replyment.answer11 || "";
          answer12.value = replyment.answer12 || "";
          answer13.value = replyment.answer13 || "";
          answer14.value = replyment.answer14 || "";
          answer15.value = replyment.answer15 || "";
        }
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const validate = async (): Promise<boolean> => {
  await replyment_body_field.validate();
  await answer1_field.validate();
  await answer2_field.validate();
  await answer3_field.validate();
  await answer4_field.validate();
  await answer5_field.validate();
  await answer6_field.validate();
  await answer7_field.validate();
  await answer8_field.validate();
  await answer9_field.validate();
  await answer10_field.validate();
  await answer11_field.validate();
  await answer12_field.validate();
  await answer13_field.validate();
  await answer14_field.validate();
  await answer15_field.validate();

  return (
    !replyment_body_error.value &&
    !answer1_error.value &&
    !answer2_error.value &&
    !answer3_error.value &&
    !answer4_error.value &&
    !answer5_error.value &&
    !answer6_error.value &&
    !answer7_error.value &&
    !answer8_error.value &&
    !answer9_error.value &&
    !answer10_error.value &&
    !answer11_error.value &&
    !answer12_error.value &&
    !answer13_error.value &&
    !answer14_error.value &&
    !answer15_error.value
  );
};

const onReply = () => {
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validate();
      if (!valid) {
        return;
      }

      await JackReplyment.register(
        request.value.id,
        salon_id.value!,
        replyment_body.value,
        answer1.value,
        answer2.value,
        answer3.value,
        answer4.value,
        answer5.value,
        answer6.value,
        answer7.value,
        answer8.value,
        answer9.value,
        answer10.value,
        answer11.value,
        answer12.value,
        answer13.value,
        answer14.value,
        answer15.value
      );
      router.push(`/jackrequests`);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};
// });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(request.value.title ?? ''), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(request.value.article ?? ''), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_unref(is_system))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(replyments.value, (replyment) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: replyment.id
                  }, [
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(_component_router_link, {
                        to: `/jackrequests/${request.value.id}/response/${replyment.salon_id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(replyment.salon_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("td", _hoisted_12, [
                      _createVNode(_component_router_link, {
                        to: `/jackrequests/${request.value.id}/response/${replyment.salon_id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(replyment.replyment_body), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(formatDate(replyment.created_at, "YYYY/MM/DD")), 1)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(is_salon))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, [
                      _createTextVNode(" 返信メッセージ "),
                      (!_unref(is_system))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, " 必須 "))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(replyment_body_error) }]),
                      placeholder: "返信メッセージ",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(replyment_body) ? (replyment_body).value = $event : null))
                    }, null, 2), [
                      [_vModelText, _unref(replyment_body)]
                    ]),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(replyment_body_error)), 1)
                  ])
                ]),
                (!!request.value.condition1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, _toDisplayString(request.value.condition1), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer1_error) }]),
                          placeholder: request.value.condition1,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(answer1) ? (answer1).value = $event : null))
                        }, null, 10, _hoisted_26), [
                          [_vModelText, _unref(answer1)]
                        ]),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(answer1_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("label", _hoisted_30, _toDisplayString(request.value.condition2), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer2_error) }]),
                          placeholder: request.value.condition2,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(answer2) ? (answer2).value = $event : null))
                        }, null, 10, _hoisted_31), [
                          [_vModelText, _unref(answer2)]
                        ]),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(answer2_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("label", _hoisted_35, _toDisplayString(request.value.condition3), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer3_error) }]),
                          placeholder: request.value.condition3,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(answer3) ? (answer3).value = $event : null))
                        }, null, 10, _hoisted_36), [
                          [_vModelText, _unref(answer3)]
                        ]),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(answer3_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("label", _hoisted_40, _toDisplayString(request.value.condition4), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer4_error) }]),
                          placeholder: request.value.condition4,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(answer4) ? (answer4).value = $event : null))
                        }, null, 10, _hoisted_41), [
                          [_vModelText, _unref(answer4)]
                        ]),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(answer4_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("label", _hoisted_45, _toDisplayString(request.value.condition5), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer5_error) }]),
                          placeholder: request.value.condition5,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(answer5) ? (answer5).value = $event : null))
                        }, null, 10, _hoisted_46), [
                          [_vModelText, _unref(answer5)]
                        ]),
                        _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(answer5_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition6)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("label", _hoisted_50, _toDisplayString(request.value.condition6), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer6_error) }]),
                          placeholder: request.value.condition6,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(answer6) ? (answer6).value = $event : null))
                        }, null, 10, _hoisted_51), [
                          [_vModelText, _unref(answer6)]
                        ]),
                        _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(answer6_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition7)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("label", _hoisted_55, _toDisplayString(request.value.condition7), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer7_error) }]),
                          placeholder: request.value.condition7,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(answer7) ? (answer7).value = $event : null))
                        }, null, 10, _hoisted_56), [
                          [_vModelText, _unref(answer7)]
                        ]),
                        _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(answer7_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition8)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("label", _hoisted_60, _toDisplayString(request.value.condition8), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer8_error) }]),
                          placeholder: request.value.condition8,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(answer8) ? (answer8).value = $event : null))
                        }, null, 10, _hoisted_61), [
                          [_vModelText, _unref(answer8)]
                        ]),
                        _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(answer8_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition9)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("label", _hoisted_65, _toDisplayString(request.value.condition9), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer9_error) }]),
                          placeholder: request.value.condition9,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(answer9) ? (answer9).value = $event : null))
                        }, null, 10, _hoisted_66), [
                          [_vModelText, _unref(answer9)]
                        ]),
                        _createElementVNode("span", _hoisted_67, _toDisplayString(_unref(answer9_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition10)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("label", _hoisted_70, _toDisplayString(request.value.condition10), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer10_error) }]),
                          placeholder: request.value.condition10,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(answer10) ? (answer10).value = $event : null))
                        }, null, 10, _hoisted_71), [
                          [_vModelText, _unref(answer10)]
                        ]),
                        _createElementVNode("span", _hoisted_72, _toDisplayString(_unref(answer10_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition11)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("label", _hoisted_75, _toDisplayString(request.value.condition11), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer11_error) }]),
                          placeholder: request.value.condition11,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(answer11) ? (answer11).value = $event : null))
                        }, null, 10, _hoisted_76), [
                          [_vModelText, _unref(answer11)]
                        ]),
                        _createElementVNode("span", _hoisted_77, _toDisplayString(_unref(answer11_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition12)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("label", _hoisted_80, _toDisplayString(request.value.condition12), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer12_error) }]),
                          placeholder: request.value.condition12,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(answer12) ? (answer12).value = $event : null))
                        }, null, 10, _hoisted_81), [
                          [_vModelText, _unref(answer12)]
                        ]),
                        _createElementVNode("span", _hoisted_82, _toDisplayString(_unref(answer12_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition13)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("label", _hoisted_85, _toDisplayString(request.value.condition13), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer13_error) }]),
                          placeholder: request.value.condition13,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(answer13) ? (answer13).value = $event : null))
                        }, null, 10, _hoisted_86), [
                          [_vModelText, _unref(answer13)]
                        ]),
                        _createElementVNode("span", _hoisted_87, _toDisplayString(_unref(answer13_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition14)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("label", _hoisted_90, _toDisplayString(request.value.condition14), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer14_error) }]),
                          placeholder: request.value.condition14,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(answer14) ? (answer14).value = $event : null))
                        }, null, 10, _hoisted_91), [
                          [_vModelText, _unref(answer14)]
                        ]),
                        _createElementVNode("span", _hoisted_92, _toDisplayString(_unref(answer14_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!!request.value.condition15)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("label", _hoisted_95, _toDisplayString(request.value.condition15), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(answer15_error) }]),
                          placeholder: request.value.condition15,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(answer15) ? (answer15).value = $event : null))
                        }, null, 10, _hoisted_96), [
                          [_vModelText, _unref(answer15)]
                        ]),
                        _createElementVNode("span", _hoisted_97, _toDisplayString(_unref(answer15_error)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("button", {
                class: _normalizeClass(["shadow text-white font-bold py-2 px-4 rounded", {
            'bg-yellow-700': !request.value.isExpired,
            'bg-gray-600': request.value.isExpired,
          }]),
                type: "button",
                onClick: _withModifiers(onReply, ["prevent"]),
                disabled: request.value.isExpired
              }, _toDisplayString(request.value.isExpired ? "回答期限が過ぎました" : "回答"), 11, _hoisted_99)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})